/**
 * @generated SignedSource<<d7aad9cd761172020fb822dbbe9829bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type infographicArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"globalCheckerContent" | "landingBannerInfographicArticle">;
  readonly " $fragmentType": "infographicArticleArticle";
};
export type infographicArticleArticle$key = {
  readonly " $data"?: infographicArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"infographicArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "infographicArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "landingBannerInfographicArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "aee74dd69dc6eb3a6881a6015938b8cb";

export default node;
